/* eslint-disable padding-line-between-statements */
import React, { useCallback, useMemo, useEffect, useContext, useState } from 'react';
import _ from 'lodash';
import { appendMetadataWithIndex } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { DateField, Icon, NumberInput } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './ViolationComponent.metadata.json5';
import messages from './ViolationComponent.messages';
import styles from './ViolationComponent.module.scss';

import { Button, InputField, DropdownSelectField } from '@jutro/legacy/components';
import classNames from 'classnames';
import { Link } from '@jutro/router';

function ViolationComponent(props) {

    const {
        id,
        value: violationsVM,
        onValueChange,
        onValidate,
        index,
        path,
        handleAddViolation
    } = props;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);	
    const { isComponentValid, onValidate: setComponentValidation } = useValidation(id);


    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        
    }, [id, isComponentValid, onValidate]);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (onValueChange) {
                onValueChange(value, changedPath);
            }
        },
        [onValueChange]
    );

    const generateNewViolationRow = useCallback(
        (event) => {
            event.preventDefault();
            if (violationsVM.value === undefined) {
                violationsVM.value = [];
            }
            const { _xCenter, _dtoName } = violationsVM;
            const violationRecordVM = viewModelService.create({},_xCenter, _dtoName);

           // violationsVM.pushElement(violationRecordVM);
            handleAddViolation(violationRecordVM);
        },
        [violationsVM, path, viewModelService, handleAddViolation ]
    );

    const getViolationTableCell =  useCallback(
        (item, index, props) => {
           let path = props.path;
           const value = item[path];
            if (props.path == 'violationDescription') {
                path  = `violations.children[${index}].${path}`;
                return (
                    <InputField
                        dataType="string"
                        id={index + path}
                        value={value}
                        path={path}
                        maxLength={500}
                        onValueChange={handleValueChange}
                    />
                );
            }
            if (props.path === 'numOfPenaltyPoints') {
                path  = `violations.children[${index}].${path}`;
                return (
                    <NumberInput
                        dataType="number"
                        id={index + path}
                        value={value}
                        path={path}
                        max={999999}
                        min={0}
                        onChange={(evnt, val) => {
                                handleValueChange(val, path);
                            }}
                    />
                );
            }
            if (props.path === 'typeOfViolation') {
                const availableValues = violationsVM.children.length > 0 ? violationsVM.children[0].typeOfViolation.aspects.availableValues.map((typeCode) => ({
                           code: typeCode.code,
                           name: translator({
                               id: typeCode.name,
                               defaultMessage: typeCode.name
                           })
                       })): [];
                   path  = `violations.value[${index}].${path}`;
                return (
                    <DropdownSelectField
                        className={styles.coverageForm}
                        id={index + path}
                        onValueChange={handleValueChange}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }
            if(props.path === 'dateOfViolation') {
                path  = `violations.children[${index}].${path}`;
                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType={_.isString(value) ? 'string' : 'object'}
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={handleValueChange}
                    />
                );
            }
        },
        [ handleValueChange]
    );

    const removeViolationRecordVM = useCallback(
        (rowIndex) => {
            violationsVM.value.splice(rowIndex, 1);
            handleValueChange(violationsVM.value, path);
        },
        [ path, handleValueChange]
    );

    const removeViolationRow = useCallback(
        (item, index) => {
            return (
                <Link
                    onClick={() => removeViolationRecordVM(index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            );
        },
        [removeViolationRecordVM]
    );



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = useMemo(() => ({
        "@field": {
            showRequired: true,
            showOptional: false,
            labelPosition: 'left',
        },
        [`violationTableSection${index}`]:{
            visible : violationsVM && violationsVM.value && violationsVM.value.length > 0
        },
        [`violationTable${index}`]:{
            data :  violationsVM ? violationsVM.value : []
        }
    }),[violationsVM]);

    const resolvers = {
        resolveCallbackMap: {
            generateNewViolationTableRow: generateNewViolationRow,
            removeViolationTableRow: removeViolationRow,
            getViolationTableCell
        }
    };

    const formattedMetadata = useMemo(() => appendMetadataWithIndex(metadata.pageContent, index), [index]);

    return (
        <ViewModelForm
            uiProps={formattedMetadata}
            model={violationsVM}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={styles}
        />
    );

}

export default ViolationComponent;